import React, { useEffect, useState } from "react";

const leastValue = 49;
const slightValue = 89;
const mostValue = 100;

const leastArcDeg = 1.31;
const slightlyArcDeg = 115 / slightValue;
const mostArcDeg = 132 / mostValue;

interface ISafetyScoreGraphSvg {
    value: any;
    isLoading: boolean;
}

const SafetyScoreGraphSvg = ({ value, isLoading }: ISafetyScoreGraphSvg) => {
    const [deg, setDeg] = useState(0);
    const [stroke, setStroke] = useState({ least: "#646464", slight: "#646464", most: "#646464" });
    const [label, setLabel] = useState("");
    const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    useEffect(() => {
        if (Number.isInteger(value)) {
            if (value === 0) {
                setStroke({
                    least: "#646464",
                    slight: "#646464",
                    most: "#646464",
                });
            } else if (value <= leastValue) {
                setDeg(value * leastArcDeg);
                setStroke({
                    least: "#de2146",
                    slight: "#646464",
                    most: "#646464",
                });
                setLabel("Least Protected");
            } else if (value > leastValue && value <= slightValue) {
                setDeg(value * slightlyArcDeg + (slightValue - value) / 12);
                setStroke({
                    least: "#de2146",
                    slight: "#e97019",
                    most: "#646464",
                });
                setLabel("Slightly Protected");
            } else {
                setDeg(value * mostArcDeg + (mostValue - value) / 10);
                setStroke({
                    least: "#de2146",
                    slight: "#e97019",
                    most: "#305191",
                });
                setLabel("Most Protected");
            }
        }
        if (value === "NA") {
            setStroke({
                least: "#646464",
                slight: "#646464",
                most: "#646464",
            });
            setLabel("Not Currently Available");
        }
    }, [value]);

    useEffect(() => {
        if (isFirefox) {
            const textPathElement = document.querySelector('textPath[href="#labelGuide"][startOffset="105"]');
            if (textPathElement) {
                textPathElement.setAttribute("startOffset", "104");
            }
        }
    }, []);

    return (
        <div className="stage">
            <svg viewBox="2 0 100 43" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="ID Safety Score Graph">
                <defs>
                    <path id="labelGuide" d="M4 36 A 51 52 0 0 1 96 35" fill="none" stroke="black" />
                </defs>
                <text className="label">
                    <textPath fontWeight="bold" href="#labelGuide" startOffset="1">
                        0
                    </textPath>
                    <textPath fontWeight="bold" href="#labelGuide" startOffset="47">
                        Least 49
                    </textPath>
                    <textPath fontWeight="bold" href="#labelGuide" startOffset="89">
                        Slightly 89
                    </textPath>
                    <textPath fontWeight="bold" href="#labelGuide" startOffset="105">
                        Most 100
                    </textPath>
                </text>
                <circle className="redArc" stroke={stroke.least} cx="50" cy="56.5" r="48.25" fill="none" strokeWidth="1.5" />
                <circle className="yellowArc" stroke={stroke.slight} cx="50" cy="56.5" r="48.25" fill="none" strokeWidth="1.5" />
                <path id="blueArc" fill="none" d="M 88.5 27.5 A 54 197 110 0 1 94.5 36.5" strokeLinecap="round" stroke={stroke.most} strokeWidth="1.5" />
                {value > 0 && (
                    <g className="markerPath" style={{ transform: `rotate(${deg}deg)` }}>
                        <circle className="rotationPath" cx="50.15" cy="56.5" r="48.25" fill="none" />
                        <circle className="marker" cx="6" cy="37" r="1.5" fill="#fff" stroke="#000" strokeWidth="0.5" />
                    </g>
                )}
                <text x="50%" y="70%" textAnchor="middle" fontWeight="lighter" fontSize="10px">
                    {!isLoading && value === "NA" ? "NA" : value}
                </text>
                <text x="50%" y="85%" textAnchor="middle" fontWeight="bold" fontSize="4px">
                    {!isLoading && value === "NA" ? "Not Currently Available" : label}
                </text>
            </svg>
        </div>
    );
};

export default SafetyScoreGraphSvg;
